export const useRandomElementFromNullableArray = <T extends unknown[]>(arr: T | null): T[number] | null => {
  if (!arr?.length) {
    return null
  }

  const index = Math.floor(Math.random() * arr.length)

  return arr[index]
}
